import { ControlTypeToNameBaseValueConverter } from 'General/Resources/ValueConverters/ControlTypeToNameBase';
export class ControlTypeToNameValueConverter extends ControlTypeToNameBaseValueConverter {

}